import { SET_VOLUME, PLAY, STOP } from "./actionTypes";

const initialState = {
  volume: 50,
  nowPlaying: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_VOLUME:
      state = {
        ...state,
        volume: action.payload,
      };
      break;
    case PLAY:
      state = {
        ...state,
        nowPlaying: action.payload,
      };
      break;
    case STOP:
      state =
        state.nowPlaying === action.payload || action.payload === null
          ? {
              ...state,
              nowPlaying: null,
            }
          : { ...state };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};
